import { OdataFieldBasicOperator } from './OdataFieldBasicOperator';
import { IOdataField } from '../../IOdataField';

export class OdataFieldHour extends OdataFieldBasicOperator {
  constructor(field: IOdataField) {
    super(field, 'hour');
  }
}
